import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken, getHeartBeatToken, getShanxiToken, removeToken, removeHeartBeatToken, removeShanxiToken } from '@/utils/auth'
import { Message } from 'element-ui'
import axios from 'axios'

Vue.use(VueRouter)

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import HomeLayout from '@/layouts/HomeLayout.vue'
import AppLayout from '@/layouts/AppLayout.vue'

const routes = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('@/views/index.vue')
      },
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/login.vue')
      },
      {
        path: 'download',
        name: 'download',
        component: () => import('@/views/download.vue')
      },
      {
        path: 'app-download',
        name: 'app-download',
        component: () => import('@/views/app-download.vue')
      },
      {
        path: 'aboutUS',
        name: 'aboutUS',
        component: () => import('@/views/aboutUS.vue')
      },
      {
        path: 'produce/physical',
        name: 'produce-physical',
        component: () => import('@/views/produce/physical.vue')
      },
      {
        path: 'produce/chemistry',
        name: 'produce-chemistry',
        component: () => import('@/views/produce/chemistry.vue')
      },
      {
        path: 'produce/biology',
        name: 'produce-biology',
        component: () => import('@/views/produce/biology.vue')
      },
      {
        path: 'produce/VR',
        name: 'produce-VR',
        component: () => import('@/views/produce/VR.vue')
      },
      {
        path: 'produce/exam',
        name: 'produce-exam',
        component: () => import('@/views/produce/exam.vue')
      },
      {
        path: 'solution',
        name: 'solution',
        component: () => import('@/views/solution/index.vue')
      },
      {
        path: 'update-log',
        name: 'update-log',
        component: () => import('@/views/update-log.vue')
      }
    ]
  },
  {
    path: '/',
    component: HomeLayout,
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home.vue')
      },
      {
        path: 'appInfo',
        name: 'appInfo',
        component: () => import('@/views/appInfo.vue')
      },
      {
        path: 'webGL',
        name: 'webGL',
        component: () => import('@/views/webGL.vue')
      },
      {
        path: 'userMessage',
        name: 'userMessage',
        component: () => import('@/views/userMessage.vue')
      },
      {
        path: 'online-app',
        name: 'online-app',
        component: () => import('@/views/online-app/index.vue')
      },
      {
        path: 'onlineCustomApp',
        name: 'onlineCustomApp',
        component: () => import('@/views/onlineCustomApp.vue')
      },
      {
        path: 'teacherExam',
        name: 'teacherExam',
        component: () => import('@/views/teacherExam.vue')
      },
      {
        path: 'studentExam',
        name: 'studentExam',
        component: () => import('@/views/studentExam.vue')
      },
      {
        path: 'summary',
        name: 'summary',
        component: () => import('@/views/summary.vue')
      }
    ]
  },
  {
    path: '/',
    component: AppLayout,
    children: [
      {
        path: 'login_desktop',
        name: 'login_desktop',
        component: () => import('@/views/login_desktop.vue')
      },
      {
        path: 'home_desktop',
        name: 'home_desktop',
        component: () => import('@/views/home_desktop.vue')
      },
      {
        path: 'appInfo_desktop',
        name: 'appInfo_desktop',
        component: () => import('@/views/appInfo_desktop.vue')
      },
      {
        path: 'userMessage_desktop',
        name: 'userMessage_desktop',
        component: () => import('@/views/userMessage_desktop.vue')
      },
      {
        path: 'onlineApp_desktop',
        name: 'onlineApp_desktop',
        component: () => import('@/views/onlineApp_desktop.vue')
      },
      {
        path: 'teacherExam_desktop',
        name: 'teacherExam_desktop',
        component: () => import('@/views/teacherExam_desktop.vue')
      },
      {
        path: 'studentExam_desktop',
        name: 'studentExam_desktop',
        component: () => import('@/views/studentExam_desktop.vue')
      },
      {
        path: 'loading_desktop',
        name: 'loading_desktop',
        component: () => import('@/views/loading_desktop.vue')
      },
      {
        path: 'custom/shanxi',
        name: 'custom-shanxi',
        component: () => import('@/views/custom/shanxi/catchall.vue')
      },
      {
        path: 'custom/shanxi/login',
        name: 'custom-shanxi-login',
        component: () => import('@/views/custom/shanxi/login.vue')
      },
      {
        path: 'custom/shanxi/app-list',
        name: 'custom-shanxi-app-list',
        component: () => import('@/views/custom/shanxi/app-list.vue')
      },
      {
        path: 'custom/shanxi/webGL',
        name: 'custom-shanxi-webGL',
        component: () => import('@/views/custom/shanxi/webGL.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/lab/',
  routes
})

let heartbeatTimers = {}

function startHeartbeat(route) {
  let hbToken = getHeartBeatToken()
  if (!hbToken) return
  let list = hbToken.split('-')
  let data = {
    client: list[0] === 'true' ? 'desktop' : 'web',
    signature: list[1]
  }
  let interval = (parseInt(list[2]) ? parseInt(list[2]) : 10) * 1000
  let timer = setInterval(() => {
    let str = getToken() ? getToken() : getShanxiToken()
    axios.post('https://api.xiyilab.com/v1/auth/heartbeat', data, {
      headers: {
        Authorization: 'Bearer ' + str
      }
    }).then(res => {
      if (res.data.status === 'no') {
        clearInterval(timer)
      }
    })
  }, interval)
  heartbeatTimers[route.path] = timer
}

router.beforeEach((to, from, next) => {
  let redirectURL = '/login?way=登录'
  let token = getToken()
  let path = to.path

  if (to.query.device === 'shanxi' && to.path === '/') {
    let data = to.query.mac ? JSON.stringify(to.query) : ''
    next('/custom/shanxi/login?device=shanxi&auth=' + to.query.auth + '&data=' + data)
    return
  }
  if (to.query.device && to.query.device.indexOf('in_school') !== -1 && to.path === '/') {
    let data = to.query.mac ? JSON.stringify(to.query) : ''
    next('/login_desktop?device=' + to.query.device + '&auth=' + to.query.auth + '&data=' + data)
    return
  }

  if (!token && (path.indexOf('/home/') !== -1 || path.indexOf('/home') !== -1)) {
    removeToken()
    next(redirectURL)
    return
  }
  if (token && (to.fullPath === '/home' || to.fullPath === '/home/')) {
    next('/home?rightPage=account')
    return
  }

  if (!token && (path.indexOf('/online-app') !== -1 || path.indexOf('/online-app/') !== -1)) {
    Message({ message: '登录信息已过期', type: 'error', duration: 3000 })
    removeToken()
    next(redirectURL)
    return
  }
  if (!token && (path.indexOf('/appInfo') !== -1 || path.indexOf('/appInfo/') !== -1)) {
    Message({ message: '登录信息已过期', type: 'error', duration: 3000 })
    removeToken()
    next(redirectURL)
    return
  }
  if (!token && (path.indexOf('/webGL/') !== -1 || path.indexOf('/webGL') !== -1)) {
    Message({ message: '登录信息已过期', type: 'error', duration: 3000 })
    removeToken()
    next(redirectURL)
    return
  }
  if (!token && (path.indexOf('/teacherExam') !== -1 || path.indexOf('/teacherExam/') !== -1)) {
    Message({ message: '登录信息已过期', type: 'error', duration: 3000 })
    removeToken()
    next(redirectURL)
    return
  }
  if (!token && (path.indexOf('/studentExam/') !== -1 || path.indexOf('/studentExam') !== -1)) {
    Message({ message: '登录信息已过期', type: 'error', duration: 3000 })
    removeToken()
    next(redirectURL)
    return
  }

  startHeartbeat(to)
  next()
})

export default router